module.exports = __webpack_public_path__ + "images/emoji/trello.7e5b95544db0fb00888d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/trello.png
// module id = yEHN
// module chunks = 2